import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import TourBanner from "./components/TourBanner";
import ScrollToTop from "./components/ScrollToTop";
import AgeVerification from "./components/AgeVerification";
import Home from "./pages/Home";
import About from "./pages/About";
import Experience from "./pages/Experience";
import Gallery from "./pages/Gallery";
import Bookings from "./pages/Bookings";
import DakotaJoy from "./pages/DakotaJoy";
import Tours from "./pages/Tours";
import Friends from "./pages/Friends";
import FAQ from "./pages/FAQ";
import Newsletter from "./pages/Newsletter";

function App() {
  return (
    <div className="App">
      <AgeVerification />
      <BrowserRouter>
        <ScrollToTop />
        <TourBanner />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/friends" element={<Friends />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/dakota-joy" element={<DakotaJoy />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
